(() => {
  if (window.technogoldRestockLoaded) return;
  window.technogoldRestockLoaded = true;
  const endpoint = 'https://technogold-avisos.ayrtonmarin1205.workers.dev/requests';
  const prepare = root => {
    const forms = root.matches?.('[data-tg-restock]') ? [root] : root.querySelectorAll?.('[data-tg-restock]') || [];
    forms.forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.querySelector('[type="submit"]').disabled = false;
    });
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches?.('[data-tg-restock]')) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('[type="submit"]');
    const label = button.textContent;
    const message = form.querySelector('.tg-restock__message');
    message.hidden = true;
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = form.dataset.sending;
    try {
      const result = await fetch(endpoint, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'omit',
        body: JSON.stringify({email: form.elements.email.value.trim(), handle: form.dataset.handle, model: form.dataset.model, website: form.elements.website.value}),
        signal: AbortSignal.timeout(25000)
      });
      const data = await result.json();
      if (!result.ok || data.ok !== true) {
        const error = new Error(result.status === 429 ? form.dataset.limit : data.error === 'available' ? form.dataset.available : form.dataset.error);
        throw error;
      }
      form.querySelector('.tg-restock__fields').hidden = true;
      form.elements.email.value = '';
      message.textContent = form.dataset.success;
      form.dataset.submitted = 'true';
    } catch (error) {
      message.textContent = [form.dataset.limit, form.dataset.available, form.dataset.error].includes(error.message) ? error.message : form.dataset.error;
    } finally {
      form.removeAttribute('aria-busy');
      message.hidden = false;
      button.textContent = label;
      button.disabled = form.dataset.submitted === 'true';
    }
  });
  prepare(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) prepare(node);
    }));
  }).observe(document.body, {childList: true, subtree: true});
})();
